<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon class="m-2" icon="edit-outline" *ngIf="action === 'edit'"></nb-icon>
        <nb-icon class="m-2" icon="plus-outline" *ngIf="action !== 'edit'"></nb-icon>
        <div *ngIf="action === 'edit'" i18n>Editing Robot Family Metadata: {{ robotFamilyMetadata.robot_family }}</div>
        <div *ngIf="action === 'clone'" i18n>Cloning Robot Family Metadata</div>
        <div *ngIf="action === 'create'" i18n>Creating Robot Family Metadata</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <form [formGroup]="metadataForm" (ngSubmit)="save()">
      <!-- Robot Family Metadata Form -->
      <br />

      <div class="row">
        <div class="col-4">
          <label i18n>Robot Family<span style="color: red">*</span>:</label>
        </div>
        <div class="col-8">
          <input
            nbInput
            placeholder="Robot Family"
            i18n-placeholder
            style="width: 100%"
            formControlName="robot_family"
          />
        </div>
        <div *ngIf="metadataForm.get('robot_family').hasError('required') && metadataForm.get('robot_family').touched">
          <p class="error" i18n>Robot Family is a required field</p>
        </div>
        <div *ngIf="metadataForm.get('robot_family').hasError('pattern')">
          <p class="error" i18n>White spaces are not allowed.</p>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-4">
          <label i18n>Metadata Type<span style="color: red">*</span>:</label>
        </div>
        <div class="col-8">
          <nb-select placeholder="Metadata Type" i18n-placeholder formControlName="metadata_type" style="width: 100%">
            <nb-option *ngFor="let metadataType of metadataTypes" [value]="metadataType">
              {{ metadataType }}
            </nb-option>
          </nb-select>
        </div>
        <div
          *ngIf="metadataForm.get('metadata_type').hasError('required') && metadataForm.get('metadata_type').touched"
        >
          <p class="error" i18n>Metadata Type is a required field</p>
        </div>
        <div *ngIf="metadataForm.hasError('validate_key')">
          <p class="error" i18n>This combination of robot family and metadata type already exists.</p>
        </div>
      </div>
      <br />

      <!-- Metadatas Form -->
      <div formArrayName="metadata">
        <div *ngFor="let met of metadata().controls; let qi = index">
          <div [formGroupName]="qi">
            <br />
            <nb-accordion>
              <nb-accordion-item>
                <nb-accordion-item-header (click)="$event.stopPropagation()">
                  <div class="col-auto mr-auto">
                    <label i18n> Extent Type {{ [qi + 1] }} </label>
                  </div>
                  <div class="col-auto" style="padding-right: 40px">
                    <button
                      nbTooltip="Delete Metadata"
                      i18n-nbTooltip
                      nbButton
                      size="small"
                      status="danger"
                      (click)="removeMetadata(qi)"
                    >
                      <nb-icon icon="trash-2-outline"></nb-icon>
                    </button>
                  </div>
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                  <nb-card>
                    <nb-card-body>
                      <div class="row">
                        <div class="col-4">
                          <label i18n>Extent Type<span style="color: red">*</span>:</label>
                        </div>
                        <div class="col-8">
                          <nb-select
                            placeholder="Extent Type"
                            i18n-placeholder
                            formControlName="extent_type"
                            style="width: 100%"
                          >
                            <nb-option *ngFor="let extentType of extentTypes" [value]="extentType">
                              {{ extentType }}
                            </nb-option>
                          </nb-select>
                          <div *ngIf="met.get('extent_type').hasError('required') && met.get('extent_type').touched">
                            <p class="error" i18n>Extent Type is a required field.</p>
                          </div>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-4">
                          <label i18n>Minimum Confidence<span style="color: red">*</span>:</label>
                        </div>
                        <div class="col-8">
                          <input
                            formControlName="confidence"
                            nbInput
                            min="0"
                            max="100"
                            type="number"
                            placeholder="Minimum Confidence"
                            i18n-placeholder
                            style="width: 100%"
                          />
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4">
                          <label i18n>Priority:</label>
                        </div>
                        <div class="col-8">
                          <input
                            formControlName="priority"
                            nbInput
                            [defaultValue]="null"
                            min="1"
                            type="number"
                            placeholder="Priority is an optional field."
                            i18n-placeholder
                            style="width: 100%"
                          />
                        </div>
                      </div>
                      <br />
                    </nb-card-body>
                  </nb-card>
                </nb-accordion-item-body>
              </nb-accordion-item>
            </nb-accordion>
          </div>
        </div>
      </div>
      <div *ngIf="metadataForm.hasError('validate_metadata')">
        <p class="error" i18n>Metadata extent_type must be unique.</p>
      </div>
      <div *ngIf="metadataForm.hasError('validate_metadata_exist')">
        <p class="error" i18n>Metadata is a required field.</p>
      </div>

      <br />
      <div class="row">
        <div class="col-auto">
          <button
            nbButton
            nbTooltip="Create New Metadata"
            i18n-nbTooltip
            size="small"
            status="success"
            type="button"
            (click)="addMetadata()"
            i18n
          >
            <nb-icon icon="plus-square-outline"></nb-icon>Add Extent Type
          </button>
        </div>
      </div>
      <br />
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton (click)="close()" i18n>Close</button>
      <button nbButton class="ml-3" status="success" (click)="save()" i18n>Save</button>
    </div>
  </nb-card-footer>
</nb-card>
